import { useContext } from "react";

import { TypographyH2, TypographyH3, TypographyP } from "./Typography";
import DottedLine from "./ui/DottedLine";
import { LanguageContext } from "./languageContext";
import { HeaderIds } from "src/helpers/uiConstants";
import DecisionMatrix from "./DecisionMatrix";

export default function WhatWeLearned() {
  const { translate } = useContext(LanguageContext);
  return (
    <div className="flex space-x-8 bg-[#F5F5F5] mx-[-20px] md:mx-0 md:rounded-3xl px-4 py-10 md:p-10">
      <DottedLine />
      <div className="space-y-4">
        <TypographyH2
          id={HeaderIds.whatWeLearnedHeader}
          textId="whatWeLearned"
        />
        <p>
          {translate("whatWeLearnedDescription")}{" "}
          <strong>{translate("whatWeLearnedDescription2")}</strong>
        </p>
        <TypographyP textId="weAlsoLearned" />
        <ul className="list-disc ml-6">
          <li>
            <strong>{translate("learning1Title")}</strong>
            <br />
            {translate("learning1Description")}
          </li>
          <li>
            <strong>{translate("learning2Title")}</strong>
            <br />
            {translate("learning2Description")}
          </li>
          <li>
            <strong>{translate("learning3Title")}</strong>
            <br />
            {translate("learning3Description")}
          </li>
          <li>
            <strong>{translate("learning4Title")}</strong>
            <br />
            {translate("learning4Description")}
          </li>
        </ul>
        <div className="flex flex-col py-10">
          <TypographyP className="text-lg font-bold" textId="studyResults" />
          <DecisionMatrix />
        </div>
        <div className="flex flex-col gap-2">
          <TypographyH3 textId="learnMore" />

          <p>
            {translate("finalStudyReport")}{" "}
            <a
              className="text-destructive underline"
              href="https://www.sfmta.com/"
            >
              {translate("finalStudyReportLink")}
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
